<template>
    <v-main>
        <v-overlay :value="Loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog
        v-model="Dialog.Informations.Model"
        width="auto">
            <v-card>
                <v-card-title>
                    Informations
                </v-card-title>
                <v-card-text>
                    <p :html="Dialog.Informations.Texte"></p>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12">
                <v-img
                src="@/assets/FIRSILOGO.png"
                contain
                max-height="50"
                max-width="150"
                class="mr-2"/>
            </v-col>
        </v-row>
        <NonAutorise v-show="!UtilisateurConnecte"/>
        <v-row v-show="UtilisateurConnecte">
            <v-col cols="12">
                <v-btn 
                large
                color="secondary"
                @click="CreerDossier"
                v-show="!MessageErreur && Creation">
                CREATION
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
        v-show="!MessageErreur && UtilisateurConnecte"
        :headers="Headers"
        :items="ListeCandidatures"
        class="elevation-1" 
        disable-pagination 
        hide-default-footer>
            <template v-slot:item={item}>
                <tr v-if="!item.supprimer">
                    <th class="text-xs-left">{{ item.anneeScolaire?.lang00 }}</th>
                    <th class="text-xs-left">{{ item.etatDossier?.lang00 }}</th>
                    <th>
                        <v-icon small class="mr-2" @click="ShowItem(item)">{{ icons.mdiEye }}</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </v-main>
</template>
<script>
import {
    mdiEye,
} from '@mdi/js'
import NonAutorise from "@/components/PageNonAutoriseExtranet"
export default {
    name:"ListeCb",
    components:{
        NonAutorise,
    },
    data(){
        return{
            // Icon importés depuis mdi/js pour les icones d'édition/suppression
            icons: {
                mdiEye,
            },
            Headers: [
                {text: 'Année scolaire', align: 'start', value: 'name', },
                { text: 'Etat du dossier', align: 'start', value: 'etat' },
                { text: '', align: 'start', value: 'action' },
                { text: '', align: 'start', value: 'valider' },
            ],
            ListeCandidatures:[],
            Loader:false,
            Creation:false,
            MessageErreur:null,
            UtilisateurConnecte:true,
            Token:null,
            Dialog:{
                Informations:{
                    Model:false,
                    Texte:null,
                }
            },
            $storeDemandeBourse : this.$storeDemandeBourse,
        }
    },
    created(){
        document.title = "Liste Candidatures Bourses";
    },
    mounted(){
        let token = this.$route.query.t;
        if(token)
        {
            this.token = token.replace(/\s/g, "+");
            this.$storeDemandeBourse.TokenExtranet = this.token;
        }
        this.loader = true;
        var self = this;
        Promise.all([
            this.$storeDemandeBourse.GetListe(token)
            .then(response=>{
                if(response){
                    if(response.data.erreur){
                        this.MessageErreur = response.data.erreur;
                        this.UtilisateurConnecte = false;
                    }
                    else{
                        this.ListeCandidatures = response.data.liste;
                        this.Creation = response.data.creer;
                        this.UtilisateurConnecte = true;
                    }
                }
            })
            .catch(error=>{
                console.log(error)
                this.loader = false;
            })
        ])
        .then(function(){
            self.loader = false;
        })
    },
    methods:{
        CreerDossier()
        {
            window.location.href = "#/bourse?t=" + this.token;
        },
        ShowItem(item)
        {
            window.location.href = "#/bourse?t=" + this.token + "&nid=" + item.encryptId;
        },
    },
}
</script>